import { Box, Toast } from "@quintoandar-tokko/jopijs";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import style from "./ToastComponent.module.scss";
import "./ToastComponent.css";
import { closeToast } from "@/store/slices/components/fichaInfo/FichaInfoSlice";

export default function ToastItem({ id, text, time = 3000, type = "success" }) {
  const [mounted, setMounted] = useState(true);
  const contRef = useRef();
  const dispatch = useDispatch();

  const TYPES = {
    success: {
      variant: "check",
      icon: "icon-check",
    },
    alert: {
      variant: "alert",
      icon: "icon-alerta_round",
    },
    danger: {
      variant: "error",
      icon: "icon-error",
    },
  };

  const timeoutRef = useRef();
  const handleClose = (idToast) => {
    if (contRef.current && contRef.current.children[0]) {
      const toastIndex = contRef.current.children[0];
      toastIndex.className = `${toastIndex.className} hideToast`;
      clearTimeout(timeoutRef.current);
      setTimeout(() => {
        setMounted(false);
        dispatch(closeToast(idToast));
      }, 500);
    }
  };

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      handleClose(id);
    }, time);
    return () => clearTimeout(timeoutRef.current);
  }, [id, time]);

  return (
    <Box ref={contRef}>
      {mounted && (
        <Toast
          className={style.toast}
          variant={TYPES[type].variant}
          text={text}
          icon={TYPES[type].icon}
          closeFunction={() => handleClose(id)}
        />
      )}
    </Box>
  );
}
